
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcNavigationItemGroup as ObcNavigationItemGroupElement} from '@oicl/openbridge-webcomponents/dist/components/navigation-item-group/navigation-item-group.js';
 
 
 

 
 export const ObcNavigationItemGroup = createComponent({
   react: React,
   tagName: 'obc-navigation-item-group',
   elementClass: ObcNavigationItemGroupElement,
   events: {
     
     onOpen: 'open' as EventName<CustomEvent<void>>,
   }
  });
 
 